export { default, getServerSideProps } from './Downloadables';
